import React, { Fragment } from 'react';
import { Show, TextField, DateField, NumberField, useTranslate } from 'react-admin';
import { Typography, makeStyles } from '@material-ui/core';
import { AmountField, LinkField, JsonTextField } from 'cw-core-admin-ui/src/components/fields';
import { Grid, GridShowLayout } from 'cw-core-admin-ui/src/components/wrapper';
import LoyaltyCreditList from '../loyaltyCredits/LoyaltyCreditList';

export const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20,
	},
	show: {
		marginBottom: 24,
	},
	list: {
		marginBottom: 24,
	},
});

export default (props) => {
	const translate = useTranslate();
	const classes = useStyles();
	return (
		<Fragment>
			<Show {...props} className={classes.show}>
				<GridShowLayout>
					<Grid container spacing={2}>
						<Grid item xs={12} md>
							<TextField source="id" />
							<TextField source="displayId" />
							<DateField source="creationDateTime" showTime />
							<TextField source="purchaseType" />
							<TextField source="purchaseStatus" />
							<AmountField source="amount" />
							<TextField source="description" />
							<TextField source="customType" />
							<TextField source="purchaseSettlementStatus" />
							<TextField source="manualSettlementComment" />
							<Grid container>
								<Grid item xs={6}>
									<AmountField source="refundedAmount" />
								</Grid>
								<Grid item xs={6}>
									<AmountField source="refundedAmountLC" />
								</Grid>
							</Grid>
							<Grid container>
								<Grid item xs={6}>
									<AmountField source="loyaltyCreditAmount" />
								</Grid>
								<Grid item xs={6}>
									<AmountField source="loyaltyCreditAmountLC" />
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12} md>
							<LinkField source="consumerWalletAccountId" type="WalletAccount" />
							<LinkField source="consumerWalletId" type="Wallet" />
							<AmountField source="consumerAmount" />
							<NumberField source="consumerExchangeRate" />
							<AmountField source="consumerLoyaltyCreditAmount" />
							<AmountField source="consumerRefundedAmount" />
							<Grid container>
								<Grid xs={6}>
									<TextField source="firstName" />
								</Grid>
								<Grid xs={6}>
									<TextField source="lastName" />
								</Grid>
							</Grid>
							<TextField source="emailAddress" />
							<JsonTextField source="billingAddress" fullWidth />
							<JsonTextField source="shippingAddress" fullWidth />
						</Grid>
						<Grid item xs={12} md>
							<LinkField source="shopConfigurationId" type="ShopConfiguration" />
							<LinkField source="walletAccountId" type="WalletAccount" />
							<LinkField source="walletId" type="Wallet" />
							<AmountField source="merchantAmount" />
							<NumberField source="merchantExchangeRate" />
							<AmountField source="merchantLoyaltyCreditAmount" />
							<AmountField source="merchantRefundedAmount" />
						</Grid>
					</Grid>
					<TextField source="redirectUrl" />
					<TextField source="shopReturnUrl" />
				</GridShowLayout>
			</Show>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.loyaltyCredits.name')}
			</Typography>
			<LoyaltyCreditList perPage={5} {...props} basePath={'/loyaltyCredits'} resource={'loyaltyCredits'} title=" " filter={{ ownerId: props.id, ownerType: 'Purchase' }} className={classes.list} />
		</Fragment>
	);
};
